<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-10 17:45:48
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 15:48:45
 * @Description: 公告列表
 -->
<template>
  <div class="list-wrapper" v-loading="loading">
    <ul v-if="noticeList.length > 0">
      <li class="list-item" v-for="(item, index) in noticeList" :key="index">
        <p class="item-text">{{ item.title }}</p>
        <p class="date">{{ item.u_time }}</p>
        <router-link :to="`m-content/${item.noticeid}`" class="title"> </router-link>
      </li>
    </ul>
    <div class="no-data" v-else>
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'announcement',
  data() {
    return {
      noticeList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      try {
        this.loading = true;
        const res = await this.$http.post('/cg/commonRequest', {
          method: 'pinfo.notice.list',
          // token:
          //   'fc2aB1JTBVEICFIGBgJSVVUGVAJSUFIED1xSAFcHBlUICFcOa1FXBQFZAVcCUQZSVAYGAAVQB1MPCgcOVQUEBAIBBQRaagdRCQFPBgFMAQAQBlIOAwUOBA4wBA',
          page: 1,
          terminal: 4
        });
        if (res.code === 200) {
          this.noticeList = res.data;
          this.noticeList.forEach(x => {
            x.u_time = x.u_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.list-wrapper {
  padding: 0.2rem;
  font-size: 0.24rem;
  .list-item {
    border-bottom: 0.02rem solid #ccc;
    line-height: 0.3rem;
    display: flex;
    justify-content: space-between;
    padding: 0.2rem;
    position: relative;
    a {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -webkit-box-orient: vertical;
      .item {
        max-width: 3.6rem;
      }
    }
  }
  .no-data {
    text-align: center;
    font-size: 0.24rem;
    line-height: 3rem;
    color: #ccc;
    background: #fff;
  }
}
</style>
